import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/admin/PageHeader";
import { Loader2 } from "lucide-react";
import { formatDateTime, formatMoney } from "@/lib/format";

export default function AdminReferrals() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/referrals").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div>
      <PageHeader title="Referrals" subtitle="Track enquiries referred to agencies and commission status" />
      <div className="rounded-lg bg-amber-50 border border-amber-200 p-3 text-xs text-amber-800 mb-5">All commission information is private and only visible to administrators.</div>
      <div className="bg-white rounded-xl border border-border overflow-hidden">
        {items === null ? <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 text-[#C81D35] animate-spin" /></div>
          : items.length === 0 ? <div className="text-center py-16 text-muted-foreground" data-testid="referrals-empty">No referrals yet. Change an enquiry's referral status to track it here.</div>
          : (
          <div className="overflow-x-auto"><table className="w-full text-sm">
            <thead><tr className="text-left text-muted-foreground border-b border-border"><th className="p-4 font-medium">Customer</th><th className="p-4 font-medium">Property</th><th className="p-4 font-medium">Agency</th><th className="p-4 font-medium">Referral status</th></tr></thead>
            <tbody>
              {items.map((e) => (
                <tr key={e.id} className="border-b border-border/60 last:border-0 hover:bg-muted/30" data-testid={`referral-row-${e.id}`}>
                  <td className="p-4"><Link to={`/admin/enquiries/${e.id}`} className="font-medium text-[#111827] hover:text-[#C81D35]">{e.full_name}</Link></td>
                  <td className="p-4 text-muted-foreground">{e.property_title || "—"}</td>
                  <td className="p-4 text-muted-foreground">{e.agency_name || "—"}</td>
                  <td className="p-4"><span className="text-xs px-2 py-1 rounded-full bg-muted">{e.referral_status}</span></td>
                </tr>
              ))}
            </tbody>
          </table></div>
        )}
      </div>
    </div>
  );
}
